import * as Yup from 'yup';

export const TokenRegisterValidation = Yup.object().shape({
    token: Yup.string().min(6,"Token Inválido").max(6,"Token Inválido").required('Token inválido ou incorreta.')
})
